<template>
    <div class="finance-ctas text-center" v-show="!hasError">
        <router-link v-if="!applyOnlineDisabled" :to="freeCreditCheckLink" class="btn btn-finance" tag="a" :class="{ 'disabled': loading }">Free Credit Check</router-link>
        <router-link v-if="!applyOnlineDisabled" :to="applyForFinanceLink" class="btn btn-finance" tag="a" :class="{ 'disabled': loading }">Apply For Finance</router-link>
        <button :disabled="loading" type="button" class="btn btn-primary" :class="{ 'disabled': loading }" @click="$emit('enquire-now')">Enquire Now</button>
    </div>
</template>

<script>
export default {
    props: {
        vehicle: {
            required: true,
        },
        quote: {
            required: true,
        },
        applyOnlineDisabled: {
            required: false,
            default: false
        },
    },
    computed: {
        hasError() {
            if (this.quote == false || this.quote == 'loading') {
                return false;
            }
            if (typeof this.quote.HasError == 'undefined' || this.quote.HasError == true) {
                return true;
            }
            if (typeof this.quote.Quote == 'undefined' || typeof this.quote.Quote.QuoteLink == 'undefined') {
                return true;
            }
            return false;
        },
        loading() {
            if (this.quote == false || this.quote == 'loading') {
                return true;
            }
            if (typeof this.quote.HasError == 'undefined' || this.quote.HasError == true) {
                return true;
            }
            if (typeof this.quote.Quote == 'undefined' || typeof this.quote.Quote.QuoteLink == 'undefined') {
                return true;
            }
            return false;
        },
        freeCreditCheckLink() {
            if (this.loading) {
                return { name: 'finance-application', params: { applicationType: 'soft', id: this.vehicle.id, quoteRef: 'none' } };
            }
            return { name: 'finance-application', params: { applicationType: 'soft', id: this.vehicle.id, quoteRef: this.quote.Quote.QuoteReference } }
        },
        applyForFinanceLink() {
            if (this.loading) {
                return { name: 'finance-application', params: { applicationType: 'full', id: this.vehicle.id, quoteRef: 'none' } };
            }
            return { name: 'finance-application', params: { applicationType: 'full', id: this.vehicle.id, quoteRef: this.quote.Quote.QuoteReference } }
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Finance/FinanceCallToActions.vue